import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

import IconButton from '@material-ui/core/IconButton'
import ArrowBackIOS from '@material-ui/icons/ArrowBackIos'
import ArrowForwardIOS from '@material-ui/icons/ArrowForwardIos'

const styles = theme => ({
  root: {
    height: 97,
    textAlign: 'right',
    userSelect: 'none',
  },
  page: {
    color: 'black',
    fontSize: 16,
    display: 'inline-block',
    textAlign: 'center',
    fontWeight: 300,
    paddingTop: 4,
    margin: 2,
    height: 26,
    minWidth: 26,
    padding: '0 2px',
    cursor: 'pointer',
    borderRadius: 13,
  },
  selected: {
    color: theme.palette.white,
    background: theme.palette.primary.main,
    $nest: {
      '&:hover': {
        color: theme.palette.white,
      },
    },
  },
  arrowDisabled: {
    color: theme.palette.background.dark,
  },
  arrowEnabled: {
    color: theme.palette.black,
  },
})

const PaginationControl = ({
  classes,
  pagination,
  onPageChange,
  generatePagesArray,
}) => {
  const pages = pagination ? generatePagesArray() : null
  const currentPage = Math.ceil(pagination.offset / pagination.limit) + 1

  return (
    <div className={classes.root}>
      {pages && pages.length > 1 ? (
        <Fragment>
          <div style={{ display: 'inline-block', height: 48 }} />
          <IconButton
            disabled={currentPage === 1}
            onClick={() => {
              onPageChange(pagination.offset - pagination.limit)
            }}>
            <ArrowBackIOS
              className={classNames(currentPage === 1 ? classes.arrowDisabled : classes.arrowEnabled)}
            />
          </IconButton>
          {pages.map((item, index) => {
            return item === '...' ? (
              <span key={index} style={{ padding: 10 }}>
                . .
              </span>
            ) : (
              <a
                onClick={() => {
                  onPageChange((item - 1) * pagination.limit)
                }}
                className={classNames(
                  classes.page,
                  item === currentPage && classes.selected
                )}
                key={index}>
                {item}
              </a>
            )
          })}
          <IconButton
            disabled={currentPage === pages[pages.length - 1]}
            onClick={() => {
              onPageChange(pagination.offset + pagination.limit)
            }}>
            <ArrowForwardIOS
              className={classNames(currentPage === pages[pages.length - 1]
                ? classes.arrowDisabled
                : classes.arrowEnabled)}
            />
          </IconButton>
        </Fragment>
      ) : null}
    </div>
  )
}

PaginationControl.propTypes = {
  classes: PropTypes.object,
  pagination: PropTypes.object,
  onPageChange: PropTypes.func,
  paginationRange: PropTypes.number,
  generatePagesArray: PropTypes.func,
  calculatePageNumber: PropTypes.func,
}

PaginationControl.defaultProps = {
  paginationRange: 5,
}

export default withStyles(styles)(PaginationControl)



// WEBPACK FOOTER //
// ./src/components/organisms/PaginationControl/PaginationControl.js